// tslint:disable
export var LocationCorrection;
(function (LocationCorrection) {
    // LACSLink conversion
    LocationCorrection[LocationCorrection["LacsLinkConversion"] = 1] = "LacsLinkConversion";
    // Derived primary number
    LocationCorrection[LocationCorrection["DerivedPrimaryNumber"] = 2] = "DerivedPrimaryNumber";
    // City name determined by ZIP4 alternate
    LocationCorrection[LocationCorrection["CityDerivedFromZip4Alternate"] = 3] = "CityDerivedFromZip4Alternate";
    // Street name changed to preferred alias
    LocationCorrection[LocationCorrection["StreetNameChanged"] = 4] = "StreetNameChanged";
    // Input ZIP4 retained
    LocationCorrection[LocationCorrection["Zip4Retained"] = 8] = "Zip4Retained";
    // Directional or Suffix changed
    LocationCorrection[LocationCorrection["DirectionalOrSuffixChanged"] = 9] = "DirectionalOrSuffixChanged";
    // City changed
    LocationCorrection[LocationCorrection["CityChanged"] = 10] = "CityChanged";
    // Added unit designator and secondary number
    LocationCorrection[LocationCorrection["AddedUnitAndSecondaryNumber"] = 11] = "AddedUnitAndSecondaryNumber";
    // Implied city based on ZIP
    LocationCorrection[LocationCorrection["CityDerivedFromZip"] = 12] = "CityDerivedFromZip";
    // Modified primary or secondary number
    LocationCorrection[LocationCorrection["ModifiedPrimaryOrSecondaryNumber"] = 13] = "ModifiedPrimaryOrSecondaryNumber";
    // Pre or post directional change
    LocationCorrection[LocationCorrection["PreOrPostDirectionalChange"] = 15] = "PreOrPostDirectionalChange";
    // City name changed
    LocationCorrection[LocationCorrection["CityNameChanged"] = 17] = "CityNameChanged";
    // Street suffix changed
    LocationCorrection[LocationCorrection["StreetSuffixChanged"] = 18] = "StreetSuffixChanged";
    // Directional shift
    LocationCorrection[LocationCorrection["DirectionalShift"] = 19] = "DirectionalShift";
    // ZIP code changed
    LocationCorrection[LocationCorrection["ZipChanged"] = 22] = "ZipChanged";
    // State changed
    LocationCorrection[LocationCorrection["StateChanged"] = 23] = "StateChanged";
    // Swapped Line 1 and Line 2
    LocationCorrection[LocationCorrection["SwappedLine1AndLine2"] = 30] = "SwappedLine1AndLine2";
    // Dropped invalid info in Line 2
    LocationCorrection[LocationCorrection["DroppedInvalidLine2"] = 31] = "DroppedInvalidLine2";
})(LocationCorrection || (LocationCorrection = {}));
LocationCorrection['LACSLINKCONVERSION'] = 1;
LocationCorrection['DERIVEDPRIMARYNUMBER'] = 2;
LocationCorrection['CITYDERIVEDFROMZIP4ALTERNATE'] = 3;
LocationCorrection['STREETNAMECHANGED'] = 4;
LocationCorrection['ZIP4RETAINED'] = 8;
LocationCorrection['DIRECTIONALORSUFFIXCHANGED'] = 9;
LocationCorrection['CITYCHANGED'] = 10;
LocationCorrection['ADDEDUNITANDSECONDARYNUMBER'] = 11;
LocationCorrection['CITYDERIVEDFROMZIP'] = 12;
LocationCorrection['MODIFIEDPRIMARYORSECONDARYNUMBER'] = 13;
LocationCorrection['PREORPOSTDIRECTIONALCHANGE'] = 15;
LocationCorrection['CITYNAMECHANGED'] = 17;
LocationCorrection['STREETSUFFIXCHANGED'] = 18;
LocationCorrection['DIRECTIONALSHIFT'] = 19;
LocationCorrection['ZIPCHANGED'] = 22;
LocationCorrection['STATECHANGED'] = 23;
LocationCorrection['SWAPPEDLINE1ANDLINE2'] = 30;
LocationCorrection['DROPPEDINVALIDLINE2'] = 31;
//# sourceMappingURL=LocationCorrection.js.map